module.exports = __webpack_public_path__ + "static/media/webpack-icon.c500a380.png";